import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Helper } from 'src/app/shared/Helper';

interface DistribuidorRegiao {
  distribuidorRegiaoId: string;
  regiaoFk: string;
  regiaoNome: string;
  regiaoEstado: string;
}

interface Distribuidor {
  usuarioId: string;
  nome: string;
  login: string;
  ativo: boolean;
  isDistribuidor: boolean;
  regioes: DistribuidorRegiao[];
}

interface RegiaoDisponivel {
  regiaoId: string;
  nome: string;
  estado: string;
  ativo: boolean;
  usuarioFk: string;
}

interface ItemSelecao {
  id: string;
  descricao: string;
  detalhe: string;
}

interface LeedTransferencia {
  leedId: string;
  nome: string;
  cidade: string;
  estado: string;
  status: string;
  dataCadastro: string;
  selecionado?: boolean;
}

@Component({
  selector: 'app-distribuidor',
  templateUrl: './distribuidor.component.html',
  styleUrls: ['./distribuidor.component.css']
})
export class DistribuidorComponent implements OnInit {
  public distribuidores: Distribuidor[] = [];
  public regioes: RegiaoDisponivel[] = [];

  public filtroNome = '';
  public filtroNr = '';
  public filtroRegiao = '';

  public carregando = false;
  public mensagem = '';
  public modalAberto = false;
  public modalTitulo = '';
  public modalSubtitulo = '';
  public modalFiltro = '';
  public modalCarregando = false;
  public modalVazioMensagem = 'Nenhum item disponível para seleção.';
  public modalItens: ItemSelecao[] = [];
  public modalSelecionadoId = '';
  private modalAcao: 'associar' | 'transferir' | '' = '';
  private modalDistribuidorId = '';
  private modalRegiaoId = '';

  public modalTipoAberto = false;
  private modalTipoRegiao: DistribuidorRegiao | null = null;
  private transferirLeeds = false;

  public modalLeedsAberto = false;
  public modalLeedsCarregando = false;
  public modalLeedsMensagem = '';
  public modalLeedsItens: LeedTransferencia[] = [];
  private pendingUsuarioFk = '';
  private pendingRegiaoFk = '';

  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit() {
    this.carregarTela();
  }

  public goToHome() {
    Helper.NavToDashboard(this.router, 'Leads');
  }

  public carregarTela() {
    this.carregando = true;
    this.mensagem = '';

    let url = Helper.baseApiUrl + 'distribuidor';
    const params: string[] = [];

    if ((this.filtroNome || '').trim()) {
      params.push('filtroNome=' + encodeURIComponent((this.filtroNome || '').trim()));
    }

    if ((this.filtroNr || '').trim()) {
      params.push('filtroNr=' + encodeURIComponent((this.filtroNr || '').trim()));
    }

    if ((this.filtroRegiao || '').trim()) {
      params.push('filtroRegiao=' + encodeURIComponent((this.filtroRegiao || '').trim()));
    }

    if (params.length > 0) {
      url += '?' + params.join('&');
    }

    this.http.get<Distribuidor[]>(url).subscribe((res) => {
      this.distribuidores = res || [];
      this.http.get<RegiaoDisponivel[]>(Helper.baseApiUrl + 'distribuidor/regioes').subscribe((regioesRes) => {
        this.regioes = (regioesRes || []).filter(r => r.ativo);
        this.carregando = false;
      }, () => {
        this.carregando = false;
        this.mensagem = 'Erro ao carregar regiões.';
      });
    }, () => {
      this.carregando = false;
      this.mensagem = 'Erro ao carregar distribuidores.';
    });
  }

  public associarRegiao(distribuidor: Distribuidor) {
    if (!distribuidor || !distribuidor.usuarioId) {
      return;
    }

    this.abrirModalSelecao(
      'associar',
      'Associar região',
      'Selecione uma região para associar ao distribuidor ' + distribuidor.nome,
      distribuidor.usuarioId,
      '',
      'Nenhuma região disponível para associação.'
    );
    this.carregarItensModal();
  }

  private confirmarAssociacao(usuarioId: string, regiaoId: string) {
    this.http.post(Helper.baseApiUrl + 'distribuidor/associar', {
      usuarioFk: usuarioId,
      regiaoFk: regiaoId
    }).subscribe(() => {
      this.mensagem = '';
      this.carregarTela();
    }, (err) => {
      this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao associar região.';
    });
  }

  public transferirRegiao(regiao: DistribuidorRegiao) {
    if (!regiao || !regiao.regiaoFk) {
      return;
    }

    this.mensagem = '';
    this.modalTipoRegiao = regiao;
    this.modalTipoAberto = true;
  }

  public fecharModalTipo() {
    this.modalTipoAberto = false;
    this.modalTipoRegiao = null;
  }

  public escolherTipoTransferencia(comLeeds: boolean) {
    const regiao = this.modalTipoRegiao;
    this.fecharModalTipo();

    if (!regiao) {
      return;
    }

    this.transferirLeeds = comLeeds;

    this.abrirModalSelecao(
      'transferir',
      'Transferir região',
      'Selecione o novo distribuidor para a região ' + regiao.regiaoNome,
      '',
      regiao.regiaoFk,
      'Nenhum distribuidor disponível para transferência.'
    );
    this.carregarItensModal();
  }

  private confirmarTransferencia(regiaoFk: string, usuarioFk: string, leedIds: string[]) {
    this.http.put(Helper.baseApiUrl + 'distribuidor/transferir', {
      usuarioFk: usuarioFk,
      regiaoFk: regiaoFk,
      leedIds: leedIds || []
    }).subscribe(() => {
      this.mensagem = '';
      this.transferirLeeds = false;
      this.carregarTela();
    }, (err) => {
      this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao transferir região.';
    });
  }

  public abrirModalLeeds() {
    this.modalLeedsAberto = true;
    this.modalLeedsCarregando = true;
    this.modalLeedsMensagem = '';
    this.modalLeedsItens = [];

    this.http.get<LeedTransferencia[]>(Helper.baseApiUrl + 'distribuidor/leeds-transferencia/' + this.pendingRegiaoFk)
      .subscribe((res) => {
        this.modalLeedsItens = (res || []).map(l => ({ ...l, selecionado: true }));
        this.modalLeedsCarregando = false;
      }, (err) => {
        this.modalLeedsCarregando = false;
        this.modalLeedsMensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao carregar leeds para transferência.';
      });
  }

  public fecharModalLeeds() {
    this.modalLeedsAberto = false;
    this.modalLeedsCarregando = false;
    this.modalLeedsMensagem = '';
    this.modalLeedsItens = [];
    this.transferirLeeds = false;
    this.pendingRegiaoFk = '';
    this.pendingUsuarioFk = '';
  }

  public marcarTodosLeeds(marcar: boolean) {
    this.modalLeedsItens.forEach(l => l.selecionado = marcar);
  }

  public confirmarTransferenciaComLeeds() {
    const leedIds = this.modalLeedsItens.filter(l => l.selecionado).map(l => l.leedId);
    const regiaoFk = this.pendingRegiaoFk;
    const usuarioFk = this.pendingUsuarioFk;

    this.modalLeedsAberto = false;
    this.modalLeedsCarregando = false;
    this.modalLeedsMensagem = '';
    this.modalLeedsItens = [];
    this.transferirLeeds = false;
    this.pendingRegiaoFk = '';
    this.pendingUsuarioFk = '';

    this.confirmarTransferencia(regiaoFk, usuarioFk, leedIds);
  }

  public desassociar(item: DistribuidorRegiao) {
    if (!item || !item.distribuidorRegiaoId) {
      return;
    }

    if (!confirm('Deseja realmente desassociar a região?')) {
      return;
    }

    this.http.delete(Helper.baseApiUrl + 'distribuidor/desassociar/' + item.distribuidorRegiaoId).subscribe(() => {
      this.mensagem = '';
      this.carregarTela();
    }, (err) => {
      this.mensagem = err && err.error && err.error.msg ? err.error.msg : 'Erro ao desassociar região.';
    });
  }

  public nomeDistribuidor(usuarioId: string) {
    const dist = this.distribuidores.find(d => d.usuarioId === usuarioId);
    return dist ? dist.nome : '';
  }

  public fecharModal() {
    this.modalAberto = false;
    this.modalTitulo = '';
    this.modalSubtitulo = '';
    this.modalFiltro = '';
    this.modalCarregando = false;
    this.modalItens = [];
    this.modalSelecionadoId = '';
    this.modalAcao = '';
    this.modalDistribuidorId = '';
    this.modalRegiaoId = '';
  }

  public onModalFiltroChange() {
    this.carregarItensModal();
  }

  public selecionarItemModal(itemId: string) {
    this.modalSelecionadoId = itemId;
  }

  public confirmarModal() {
    if (!this.modalSelecionadoId) {
      this.mensagem = 'Selecione um item para continuar.';
      return;
    }

    const acaoAtual = this.modalAcao;
    const usuarioIdAtual = this.modalDistribuidorId;
    const regiaoIdAtual = this.modalRegiaoId;
    const itemSelecionado = this.modalSelecionadoId;
    this.fecharModal();

    if (acaoAtual === 'associar') {
      this.confirmarAssociacao(usuarioIdAtual, itemSelecionado);
      return;
    }

    if (acaoAtual === 'transferir') {
      this.pendingRegiaoFk = regiaoIdAtual;
      this.pendingUsuarioFk = itemSelecionado;

      if (this.transferirLeeds) {
        this.abrirModalLeeds();
      } else {
        this.confirmarTransferencia(regiaoIdAtual, itemSelecionado, []);
      }
    }
  }

  private abrirModalSelecao(acao: 'associar' | 'transferir', titulo: string, subtitulo: string, usuarioId: string, regiaoId: string, msgVazio: string) {
    this.mensagem = '';
    this.modalAcao = acao;
    this.modalTitulo = titulo;
    this.modalSubtitulo = subtitulo;
    this.modalVazioMensagem = msgVazio;
    this.modalDistribuidorId = usuarioId || '';
    this.modalRegiaoId = regiaoId || '';
    this.modalFiltro = '';
    this.modalItens = [];
    this.modalSelecionadoId = '';
    this.modalCarregando = true;
    this.modalAberto = true;
  }

  private carregarItensModal() {
    if (!this.modalAcao) {
      return;
    }

    this.modalCarregando = true;
    let url = '';
    const filtro = (this.modalFiltro || '').trim();
    const query = filtro ? '?filtro=' + encodeURIComponent(filtro) : '';

    if (this.modalAcao === 'associar') {
      url = Helper.baseApiUrl + 'distribuidor/regioes-disponiveis/' + this.modalDistribuidorId + query;
      this.http.get<any[]>(url).subscribe((res) => {
        this.modalItens = (res || []).map(r => ({
          id: r.regiaoId,
          descricao: r.nome,
          detalhe: r.estado
        }));
        this.ajustarSelecaoModal();
        this.modalCarregando = false;
      }, () => {
        this.modalCarregando = false;
        this.mensagem = 'Erro ao carregar regiões disponíveis.';
      });
      return;
    }

    url = Helper.baseApiUrl + 'distribuidor/distribuidores-destino/' + this.modalRegiaoId + query;
    this.http.get<any[]>(url).subscribe((res) => {
      this.modalItens = (res || []).map(d => ({
        id: d.usuarioId,
        descricao: d.nome,
        detalhe: ((d.login || '') + (d.email ? ' • ' + d.email : '')).trim()
      }));
      this.ajustarSelecaoModal();
      this.modalCarregando = false;
    }, () => {
      this.modalCarregando = false;
      this.mensagem = 'Erro ao carregar distribuidores de destino.';
    });
  }

  private ajustarSelecaoModal() {
    if (!this.modalItens || this.modalItens.length === 0) {
      this.modalSelecionadoId = '';
      return;
    }

    const selecionadoExiste = this.modalItens.some(i => i.id === this.modalSelecionadoId);
    if (!selecionadoExiste) {
      this.modalSelecionadoId = this.modalItens[0].id;
    }
  }
}
